import request from '@/utils/request/index.js';

export const login = (params) => {
  let headers = {
    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
  };

  return request({
    url: '/oauth/token',
    withCredentials: true,
    data:
      'grant_type=password&scope=' + Math.random() + '&username=' +
      encodeURIComponent(params.email) +
      '&password=' +
      encodeURIComponent(params.password),
    auth: {
      username: 'browser',
      password: 'browser'
    },
    method: 'post',
    headers: headers
  });
};
